import { render, staticRenderFns } from "./LastFeaturedItem.vue?vue&type=template&id=7af7c308&scoped=true&"
import script from "./LastFeaturedItem.vue?vue&type=script&lang=js&"
export * from "./LastFeaturedItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af7c308",
  null
  
)

export default component.exports